import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeLimiteCaractere3'
})
export class PipeLimiteCaractere3 implements PipeTransform {
    transform(value: string): string {
        if(value == null || value == undefined){
            return ''
        }
        if(value && value.length > 40){
            return value.substr(0, 40) + '...';
        }else{
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeLimiteCaractere3.ts